import React from 'react';
import { formatCurrency } from '../../utils/formatCurrency';

/**
 * PaymentTotals - Final totals breakdown for payment page
 * 
 * Shows:
 * - Subtotal
 * - Discount (if any)
 * - Tax
 * - Tip (highlighted when present)
 * - Final Total (large, emphasized)
 */
export default function PaymentTotals({
  subtotal = 0,
  discount = 0,
  discountLabel = '',
  tax = 0,
  tip = 0,
  total = 0,
  className = '',
}) {
  const hasDiscount = discount > 0;
  const hasTip = tip > 0;

  return (
    <div className={`space-y-3 ${className}`}>
      {/* Subtotal */}
      <div className="flex items-center justify-between">
        <span className="text-base text-gray-400">Subtotal</span>
        <span className="text-base text-white">
          {formatCurrency(subtotal)}
        </span>
      </div>

      {/* Discount */}
      {hasDiscount && (
        <div className="flex items-center justify-between text-[#10b981]">
          <span className="text-base">
            Discount
            {discountLabel && (
              <span className="ml-2 text-sm opacity-80">({discountLabel})</span>
            )}
          </span>
          <span className="text-base font-medium">
            -{formatCurrency(discount)}
          </span>
        </div>
      )}

      {/* Tax */}
      <div className="flex items-center justify-between">
        <span className="text-base text-gray-400">Tax</span>
        <span className="text-base text-white">
          {formatCurrency(tax)}
        </span>
      </div>

      {/* Tip */}
      <div className={`flex items-center justify-between ${hasTip ? 'text-[#f5a623]' : 'text-gray-400'}`}>
        <span className="text-base">Tip</span>
        <span className={`text-base ${hasTip ? 'font-semibold' : ''}`}>
          {hasTip ? formatCurrency(tip) : '$0.00'}
        </span>
      </div>

      {/* Divider */}
      <div className="h-px bg-white/10 my-2" />

      {/* Total */}
      <div className="flex items-center justify-between pt-1">
        <span className="text-xl font-semibold text-white">Total</span>
        <span className="text-3xl font-bold text-[#f5a623]">
          {formatCurrency(total)}
        </span>
      </div>
    </div>
  );
}
